<template>
  <div class="container col-md-8 offset-md-2 mt-5">
    <div class="card p-3 mb-3 card-lg shadow steps-card">
      <div class="container text-black">
        <div class="text-left my-3 font-25px steps-title">{{ $t("additional_information") }}</div>
        <!-- Start card content -->
        <div>
          <!-- <div class="form-row">
            <div class="col-lg-12 form-group">
              <select
                class="custom-select form-control"
                :class="{ 'is-invalid': $v.otherInfo.business_incubator.$error }"
                @focus="showHideLabel('business_incubator')"
                @blur="showHideLabel('business_incubator')"
                v-model.trim="$v.otherInfo.business_incubator.$model"
                required
              >
                <option :value="null" selected disabled class="custom-select-placeholder">{{ $t("which_business_incubator") }} *</option>
                <option v-for="option in businessIncubatorSelect.options" :value="option.option_ita">{{ option.option }}</option>
              </select>
              <small id="business_incubator_label" style="display: none" class="mt-2"> {{ $t("which_business_incubator") }} *</small>
            </div>
          </div> -->

          <div class="form-row mb-5">
            <div class="col-lg-12 form-group">
              <select
                class="custom-select form-control"
                :class="{ 'is-invalid': $v.otherInfo.how_found_us.$error }"
                @focus="showHideLabel('how_found_us')"
                @blur="showHideLabel('how_found_us')"
                v-model.trim="$v.otherInfo.how_found_us.$model"
                required
              >
                <option :value="null" selected disabled class="custom-select-placeholder">{{ $t("how_found_us") }} *</option>
                <option v-for="option in howFoundUsSelect.options" :value="option.option_ita">{{ option.option }}</option>
              </select>
              <small id="how_found_us_label" style="display: none" class="mt-2">{{ $t("how_found_us") }} *</small>
            </div>
          </div>

          <div v-show="otherInfo.projectQueries && otherInfo.projectQueries.length > 0" class="form-row">
            <div class="form-row col-lg-12" v-for="(projectQuery, pqi) in otherInfo.projectQueries">
              <div class="col-lg-10 font-16px" v-html="projectQuery.description"></div>
              <div class="col-lg-2 from-group">
                <input v-model="projectQuery.response" type="radio" :name="'procedt[1]['+pqi+']'" :id="'procedt[1]['+pqi+']'" :value="1" class="radio-btn" />
                <label :for="'procedt[1]['+pqi+']'" class="btn btn-checkbox mr-2">{{ $t("yes") }}</label>

                <input v-model="projectQuery.response" type="radio" :name="'procedt[1]['+pqi+']'" :id="'procedt[0]['+pqi+']'" :value="0" class="radio-btn" />
                <label :for="'procedt[0]['+pqi+']'" class="btn btn-checkbox mr-2">{{ $t("no") }}</label>
              </div>
              <small v-if="$v.otherInfo.projectQueries.$each[pqi].$error" class="text-danger">{{ $t("last_five_years_required") }}</small>
            </div>
          </div>
          <div class="mb-20"></div>
          <div
            class="p-5 wizard_navigator custom-row justify-content-between justify-content-center text-white font-lato-regular fixed-bottom sticky-bottom-bar"
            data-offset="-60"
            style="background-color: #f2b12d"
          >
            <div class="font-16px hover-mouse-pointer" @click="previous()"><i class="tio-arrow-left-circle-outlined font-25px"></i> {{ $t("back") }}</div>
            <div class="font-16px hover-mouse-pointer" @click="saveOtherInfo()">{{ $t("forward") }} <i class="tio-arrow-right-circle-outlined font-25px"></i></div>
          </div>
        </div>
        <!-- End Card content-->
      </div>
    </div>

    <div class="col-12 text-center mt-6 stick-up-bottom-element">
      <button v-on:click="saveForLater" class="btn btn-secondary">{{ $t("save_and_continue") }}</button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "OtherInfo",
  props: ["editionQueriesProp", "projectProp", "route", "previousRoute", "businessIncubatorSelect", "howFoundUsSelect"],
    mounted() {
    this.otherInfo = this.projectProp;
    this.otherInfo.projectQueries = [];
    // indicizzo le domande di project per id
      let projectQueriesIndexed = [];
      this.projectProp.project_queries.forEach(query => {
        projectQueriesIndexed[query.edition_query_id] = query.response;
      });

    this.editionQueriesProp.forEach(editionQuery => {
      this.otherInfo.projectQueries.push({
        "description": editionQuery.description,
        "edition_query_id": editionQuery.id,
          "response": projectQueriesIndexed[editionQuery.id] != undefined ? projectQueriesIndexed[editionQuery.id] : null
      });
    });
  },
  data() {
    return {
      project: {},
      otherInfo: {
        // business_incubator: null,
        how_found_us: null,
        projectQueries:[]
      },
    };
  },
  validations: {
    otherInfo: {
      // business_incubator: { required },
          how_found_us: { required },
          projectQueries: {
                $each: {
                    response: {
                        required
                    }
                }
            }

    },
  },

  methods: {
    saveForLater() {
      this.$v.$touch();

      this.otherInfo.later = true;

      if (!this.$v.$anyError) {
        axios.post(this.route, this.otherInfo).then((response) => {
          window.location.href = response.data.redirect;
        });
      }
    },
    saveOtherInfo() {
      this.$v.$touch();

      if (!this.$v.$anyError) {
        axios.post(this.route, this.otherInfo).then((response) => {
            window.location.href = response.data.redirect;
        });
      }
      else {
      }
    },
    previous() {
      window.location.href = this.previousRoute;
    },
    showHideLabel(label) {
      var x = document.getElementById(label + "_label");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        var my_label = "this.otherInfo." + label;

        if (!eval(my_label)) x.style.display = "none";
      }
    },
  },
};
</script>

<style scoped>
</style>
